(function () {
  function normalizeModel(value) {
    return (value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function syncModelTabs(root) {
    var param = root.dataset.modelFilterParam;
    var activeClass = root.dataset.tabActiveClass;
    if (!param || !activeClass) return;

    var params = new URLSearchParams(window.location.search);
    var activeModel = params.get(param);
    var tabs = root.querySelectorAll('[role="tab"][data-filter-value]');

    tabs.forEach(function (tab) {
      var tabValue = tab.dataset.filterValue || '';
      var isFirstTab = tab.dataset.firstTab === 'true';
      var isActive = activeModel
        ? normalizeModel(tabValue) === normalizeModel(activeModel)
        : isFirstTab;

      tab.classList.toggle(activeClass, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function initModelTabs() {
    document.querySelectorAll('[data-mossa-model-tabs]').forEach(syncModelTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModelTabs);
  } else {
    initModelTabs();
  }

  window.addEventListener('popstate', initModelTabs);
})();
